import { render } from "./PropButton.vue?vue&type=template&id=3a3fa237&scoped=true"
import script from "./PropButton.vue?vue&type=script&lang=js"
export * from "./PropButton.vue?vue&type=script&lang=js"

import "./PropButton.vue?vue&type=style&index=0&id=3a3fa237&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3fa237"]])

export default __exports__